import React from "react";
import Link from "next/link";

const UnderConstruction: React.FC = () => {
    return (
        <div className="under-construction-container flex flex-col items-center justify-center min-h-[70vh] px-4 text-center bg-transparent">

            <div className="max-w-2xl w-full">
                {/* Premium Animated Construction Image */}
                <div className="relative mb-8 flex justify-center">
                    <div className="floating-svg">
                        <img
                            src="/images/under_progress.png"
                            alt="Under Construction"
                            className="w-64 h-auto md:w-80 object-contain"
                        />
                    </div>

                    {/* Pulsing Light Overlay */}
                    <div className="pulse-light absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-64 h-64 rounded-full bg-yellow-400 blur-3xl opacity-10 pointer-events-none" />
                </div>

                <h1 className="text-4xl md:text-5xl font-bold mb-4 text-[#196565]">
                    Page Under Construction
                </h1>

                <p className="text-lg text-gray-600 mb-8 max-w-lg mx-auto leading-relaxed">
This page is currently under construction. Please check back soon!                </p>



                {/* Bottom decorative elements */}
                <div className="mt-16 flex justify-center gap-2">
                    {[0, 1, 2].map((i) => (
                        <div
                            key={i}
                            className="dot-anim w-3 h-3 rounded-full bg-[#EEC906]"
                            style={{ animationDelay: `${i * 0.3}s` }}
                        />
                    ))}
                </div>
            </div>
        </div>
    );
};

export default UnderConstruction;
